// extracted by mini-css-extract-plugin
module.exports = {"happyPurchaseWrap":"_1weVW"};